import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { BaseService } from '../base/base.service';
import { SessionUserHashManagerService } from '../session-user-hash-manager/session-user-hash-manager.service';

@Injectable({
  providedIn: 'root'
})
export class AttendancesService extends BaseService {

  private apiUrl: string = environment.apiUrl;

  constructor(
    private http: HttpClient,
    protected hashManagerService: SessionUserHashManagerService
  ) {
    super(hashManagerService);
    this.apiUrl += this.apiUrl.endsWith("/") ? "" : "/";
  }

  getAttendanceList() {
    let options = this.prepareOptions({});
    return this.http.get(this.apiUrl + 'api/LearningSection/GetAttendanceTypes', options)
      .pipe(
        map((data: any) => {

          return data.body;
        }), catchError(this.handleError('getAttendanceList'))
      );
  }
}
